(function () {
  angular.module("akitabox.ui.dialogs.request", [
    "akitabox.ui.dialogs.request.create",
    "akitabox.ui.dialogs.request.deny",
    "akitabox.ui.dialogs.request.delete",
    "akitabox.ui.dialogs.request.reopen",
  ]);
})();
